export const isInternalUrl = (url)=>{
    try {
        const parsed = new URL(url, window.location.origin);
        return parsed.origin === window.location.origin;
    } catch  {
        return false;
    }
};
export const toInternalPath = (url)=>{
    if (url.substring(0, 4) !== "http") return url;
    try {
        const parsed = new URL(url, window.location.origin);
        return `${parsed.pathname}${parsed.search}${parsed.hash}`;
    } catch  {
        return url;
    }
};
